<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-select :items="selectTeacherList" v-model="query.teacher" item-text="trueName"
									item-value="id" label="教师" dense outlined clearable></v-select>
							</div>
							<div style="width: 260px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.yyyyMM" label="选择年月" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.yyyyMM" type="month"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 260px;" class="mr-1">
								<v-select :items="settleItems" v-model="query.isSettle" item-text="name"
									item-value="id" label="结算状态" dense outlined clearable></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.isSettle="{item}">
					<!-- <v-chip small :color="settleColor(item.isSettle)">{{ settleName(item.isSettle) }}
					</v-chip> -->
					<span v-if="item.isSettle=='0'" style="color:#FF9100">未结算</span>
					<span v-if="item.isSettle=='1'">已结算</span>
				</template>
				<template v-slot:item.bonusType="{item}">
					<!-- <v-chip small :color="bonusTypeColor(item.bonusType)">{{ bonusTypeName(item.bonusType) }}
					</v-chip> -->
					{{ bonusTypeName(item.bonusType) }}
				</template>
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showSettle(item)" :disabled="item.isSettle !== '0'" color="deep-purple lighten-3" small style="color: #424242;"class="mr-1">结算</v-btn>
					<v-btn @click.stop="cancelSettle(item)" :disabled="item.isSettle !== '1'" color="deep-purple lighten-3" small style="color: #424242;"class="mr-1">取消</v-btn>
					<v-btn @click.stop="showDetail(item)" color="deep-purple lighten-3" small style="color: #424242;">查看明细</v-btn>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 明细 -->
		<v-dialog title="明细列表" v-model="detail.dialog" max-width="1200">
			<v-card>
				<v-card-title style="background-color:#9575CD; height: 55px;">
					<span style="color:#ffffff; font-size: 18px;" class="mt-n1">明细列表</span>
					<v-spacer></v-spacer>
					<v-icon @click="detail.dialog=false" color="#ffffff">mdi-close-circle</v-icon>
				</v-card-title>
				
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-data-table :headers="detail.headers" :items="detail.list" :loading="detail.loading" class="elevation-1"
						disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
						
						<template v-slot:item.consumeType="{item}">
							<span  v-if="item.consumeType == '1'" style="color:green">扣课时</span>
							<span  v-if="item.consumeType == '2'" style="color:red">扣金额</span>
						</template>
						<template v-slot:item.reduceQty="{item}">
							{{item.reduceQty}}
						</template>
						<template v-slot:item.reduceFee="{item}">
							{{item.consumeType==='2'?item.reduceFee:"-"}}
						</template>
						<template v-slot:item.bonusPrice="{item}">
							<div v-if="item.status=='2'">
								<span  v-if="item.teacherBonusType !== '4'">{{item.bonusPrice}}元</span>
								<span  v-if="item.teacherBonusType === '4'">{{item.bonusPrice}}%</span>
							</div>
							
							
						</template>
						<template v-slot:item.status="{item}">
							<!-- <v-chip small :color="detailStatusColor(item.status)">{{ detailStatusName(item.status) }}
							</v-chip> -->
							<span v-if="item.status=='1'" style="color:#FF9100">未结算</span>
							<span v-if="item.status=='2'">已结算</span>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "performance-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '教师绩效列表',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '老师',
							value: 'trueName',
							sortable: false
						},
						{
							text: '年月',
							value: 'yyyyMm',
							sortable: false
						},
						{
							text: '绩效节数',
							value: 'recordCount',
							sortable: false
						},
						{
							text: '到课人次',
							value: 'recordCameCount',
							sortable: false
						},
						{
							text: '总课时数',
							value: 'reduceClassTimes',
							sortable: false
						},
						{
							text: '课时模式',
							value: 'reduceTimeHours',
							sortable: false
						},
						{
							text: '金额模式',
							value: 'reduceCashHours',
							sortable: false
						},
						{
							text: '扣学费金额',
							value: 'reduceTuitionFee',
							sortable: false
						},
						{
							text: '总消课收入',
							value: 'revenue',
							sortable: false
						},
						{
							text: '是否结算',
							value: 'isSettle',
							sortable: false
						},
						{
							text: '提成金额',
							value: 'amount',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
						
					],
					list: [],
				},
				selectTeacherList:[],
				settleItems:[
					{id:"",name:"全部"},
					{id:"1",name:"已结算"},
					{id:"0",name:"未结算"},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					yyyyMM: "",
					teacher: "",
					isSettle:""
					
				},
				settle:{
					dialog:false,
				},
				detail:{
					dialog:false,
					loadding:false,
					headers:[
						{text: '日期',value: 'classDate',sortable: false},
						{text: '班级',value: 'className',sortable: false},	
						{text: '扣费方式',value: 'consumeType',sortable: false},	
						{text: '绩效节数',value: 'addTeacherClassCount',sortable: false},	
						{text: '消课时',value: 'reduceQty',sortable: false},	
						{text: '消学费',value: 'reduceFee',sortable: false},
						{text: '消课收入',value: 'revenueFee',sortable: false},
						{text: '课程原价',value: 'originFee',sortable: false},
						{text: '提成基数',value: 'calBonusFee',sortable: false},
						{text: '提成价格',value: 'bonusPrice',sortable: false},
						{text: '提成金额',value: 'bonusFee',sortable: false},
						{text: '状态',value: 'status',sortable: false},
					],
					list:[]
				}
			}
		},
		created() {
			this.getTeacherListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showSettle(item){
				this.settle.dialog = true;
				
				// api
				const that = this;
				let url = `/financial/month/performance/settle/${item.id}`;
			
				
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			cancelSettle(item){
				// 取消结算
				// api
				const that = this;
				let url = `/financial/month/performance/settle/cancel/${item.id}`;
							
				
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				const shopId = utils.getCurrentShopId();
				

				let url = `/financial/performance/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				
				if (this.query.yyyyMM) {
					url += "&yyyyMM=" + this.query.yyyyMM;
				}
				if (this.query.isSettle) {
					url += "&isSettle=" + this.query.isSettle;
				}
				
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			settleName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "已结算";
				} else if (state === "0") {
					stName = "未结算";
				}
				return stName;
			},
			settleColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			consumeName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "扣课时";
				} else if (state === "2") {
					stName = "扣学费";
				}
				return stName;
			},
			consumeColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
			
				return color;
			},
			detailStatusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "未结算";
				} else if (state === "2") {
					stName = "已结算";
				}else if (state === "0") {
					stName = "已作废";
				}
				return stName;
			},
			detailStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "primary";
				} else if (state === "2") {
					color = "success";
				}else if (state === "0") {
					color = "error";
				}
			
				return color;
			},
			bonusTypeName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "按核销课时数";
				} else if (state === "2") {
					stName = "按到课学生数";
				}else if (state === "3") {
					stName = "按上课次数";
				}else if (state === "4") {
					stName = "按扣费分成";
				}
				return stName;
			},
			bonusTypeColor(state) {
				let color = "";
		
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "warning";
				}else if (state === "4") {
					color = "error";
				}
				return color;
			},
			showDetail(item){
				// 查看明细
				this.detail.dialog= true;
				this.detail.loadding = true;
				// 先清空
				this.detail.list = [];
				
				// 从api获取明细数据
				let performanceId = item.id;
				
				const that = this;
				let url = `/financial/performance/detail/list/${performanceId}`;
							
				this.axios.get(url).then(response => {
					that.detail.loadding = false;
					console.log(response);
					if (response.data["code"] === 200) {
						that.detail.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						
						console.log(that.detail.list);
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
				
			},
			getTeacherListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			

		}
	}
</script>

<style>
</style>
